import { useEffect, useState } from 'react';

const useDebouncedValue = (value, delayMs) => {
  const [debounced, setDebounced] = useState(value);
  const [isPending, setIsPending] = useState(false);

  const serialized = JSON.stringify(value);

  useEffect(() => {
    setIsPending(true);
    const timeout = setTimeout(() => {
      setDebounced(JSON.parse(serialized));
      setIsPending(false);
    }, delayMs);

    return () => clearTimeout(timeout);
  }, [serialized, delayMs]);

  return [debounced, isPending];
};

export default useDebouncedValue;
